import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import Button from 'components/_atoms/Button'
import DateRangeDisplay from 'components/_molecules/DateRangeDisplay'

import './styles.css'

class TripsList extends Component {
  static propTypes = {
    trips: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    })).isRequired,
    actions: PropTypes.shape({
      viewTripAsMap: PropTypes.func.isRequired,
      viewTripAsList: PropTypes.func.isRequired,
      editTrip: PropTypes.func.isRequired,
    }).isRequired,
  }

  render() {
    const {
      trips,
      actions,
    } = this.props
    return (
      <div className="TripsList">
        {trips.map((trip) => {
          const {
            id,
            name,
            startDate,
            endDate,
          } = trip
          const viewThisTripAsMap = () => {
            actions.viewTripAsMap({ tripId: id, })
          }
          const editThisTrip = () => {
            actions.editTrip({ tripId: id, })
          }
          return (
            <div className="trip-list-item" key={id}>
              <h3 className="trip-name">{name}</h3>
              <DateRangeDisplay start={startDate} end={endDate} />
              <div className="trip-actions">
                <Button role="link" className="secondary" onClick={editThisTrip}>
                  Edit
                </Button>
                <Button role="link" className="secondary" onClick={viewThisTripAsMap}>
                  View
                </Button>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default TripsList



// WEBPACK FOOTER //
// ./src/components/TripsList/index.js